import { HallowABFlag } from "./HallowABFlag.enum";

export const MixpanelABFlagValidProps = {
  [HallowABFlag.WebAdventShortOnboarding]:
    HallowABFlag.WebAdventShortOnboarding,
  [HallowABFlag.WebAppDownloadScreen]: HallowABFlag.WebAppDownloadScreen,
  [HallowABFlag.WebFamilyPlanUpgradeAdvent]:
    HallowABFlag.WebFamilyPlanUpgradeAdvent,
  [HallowABFlag.FamilyPlanOneClickUpgrade]: "family_plan_upgrade_valid",
  [HallowABFlag.WebMediumOnboarding]: "web_medium_onboarding_valid",
  [HallowABFlag.WebHomepageCTADestination]:
    "web_homepage_cta_destination_valid",
  [HallowABFlag.WebOnboardingSmsPrompt]: HallowABFlag.WebOnboardingSmsPrompt,
} as const;
